import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Input from '@Pages/ProfileSettings/Preferences/components/Input';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';

function ProfileSettingsInputSection({ name, label, value, title, validate, errorsMessages, onChange, onSave, onClose, onBlur }) {
  const [formErrors, setFormErrors] = useState(null);

  const formValid = useMemo(() => {
    return !formErrors;
  }, [formErrors]);

  // eslint-disable-next-line no-shadow
  const validateInput = (value) => {
    const { errors, isValid } = validate(value);

    if (isValid) {
      setFormErrors(null);
      return;
    }
    setFormErrors(errors.map((error) => errorsMessages[error]));
  };

  const handleInputChange = (event) => {
    // eslint-disable-next-line no-shadow
    const { value } = event.target;
    onChange(value);
    validateInput(value);
  };

  const handleClose = () => {
    setFormErrors(null);
    onClose();
  };

  const handleBlur = () => {
    onBlur(formErrors);
  };

  return (
    <ProfileSettingsAccordionItem onClose={handleClose} label={label} value={value} onSave={onSave} formValid={formValid} title={title}>
      <Input
        key={name}
        id={name}
        name={name}
        label={label}
        value={value}
        errorMessages={formErrors}
        onChange={handleInputChange}
        onBlur={handleBlur}
      />
    </ProfileSettingsAccordionItem>
  );
}

ProfileSettingsInputSection.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  errorsMessages: PropTypes.object,
};

export default ProfileSettingsInputSection;
